import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import {DataGridPro, GridToolbar} from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';


import EditIcon from '@mui/icons-material/Edit';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function SessionCustomersList(props){
    //console.debug("RTS Break SessionCustomerList");

    const {setSessionCustomer, setPrevSessionCustomer} = useSessionContext();

    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));


    function handleClick(e, cellValues){
        setSessionCustomer(cellValues.row);
        setPrevSessionCustomer(cellValues.row);
        history("*", {state: {}});
    }


    const columns = [
        {
            field: '',
            description:"Select Customer", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <EditIcon />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },
        {
            field: 'name', 
            headerName: "Name", 
            description:"Customer Name", 
            flex:3,
            valueGetter: (value, row) => {
                return row.customer.name;
            },
            hideable:false             
        },
        {
            field: 'idSap', 
            headerName: "Id", 
            description:"Customer Id", 
            flex:2,
            valueGetter: (value, row) => {
                return row.customer.idSap;
            }
        },
        {
            field: 'mailCity', 
            headerName: "City", 
            description:"Customer City", 
            flex:3,
            valueGetter: (value, row) => {
                return row.customer.mailCity;
            },
        },
        {
            field: 'mailRegion', 
            headerName: "State", 
            description:"Customer State", 
            flex:2,
            valueGetter: (value, row) => {
                return row.customer.mailRegion;
            }
        }
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {mailCity:false, mailRegion:false}
        }
        else{
            return {}
        }
    }


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    }


    return (
        <Box sx={{width:'100%', height:'100%'}}>
            <DataGridPro
                autoHeight={smallForm}
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },                        
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.customer.idGuid}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 

                }}                
            />
        </Box>
    );
}
